import { Pipe, PipeTransform } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ClientDocumentRelation } from '../model/client-document-relation.model';
import { TxDocument } from '../model/document.model';

@Pipe({
  name: 'clientDocRelationFulfilledName',
})
export class ClientDocRelationFulfilledNamePipe implements PipeTransform {
  transform(document: TxDocument, clientId: string): string {
    const relation = document.getSignerById(clientId).relation;

    switch (relation) {
      case ClientDocumentRelation.CanRead:
        return marker('CLIENT_DOC_RELATION.FULFILLED.READ');
      case ClientDocumentRelation.MustRead:
        return marker('CLIENT_DOC_RELATION.FULFILLED.READ');
      case ClientDocumentRelation.MustSign:
        return marker('CLIENT_DOC_RELATION.FULFILLED.SIGNED');
      default:
        throw new Error(`Relation Type "${document.relationType}" is not valid for a document.`);
    }
  }
}
